import { render, staticRenderFns } from "./indexNew.vue?vue&type=template&id=5b51c919&scoped=true"
import script from "./indexNew.vue?vue&type=script&lang=js"
export * from "./indexNew.vue?vue&type=script&lang=js"
import style0 from "./indexNew.vue?vue&type=style&index=0&id=5b51c919&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b51c919",
  null
  
)

export default component.exports